<template>
  <v-list-tile
    v-on="listeners"
    active-class="accent"
    :to="route">
    <v-list-tile-action>
      <v-tooltip right>
        <v-icon slot="activator">{{icon}}</v-icon>
        <span>{{text}}</span>
      </v-tooltip>
    </v-list-tile-action>

    <v-list-tile-content>
      <v-list-tile-title>{{text}}</v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>

<script>
export default {
  props: {
    routeName: {
      type: String
    },
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    }
  },

  computed: {
    listeners() {
      return {
        ...this.$listeners
      };
    },

    route() {
      if (this.routeName) {
        return {name: this.routeName};
      }
      return null;
    }
  }
};
</script>

